import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, MessagePlugin } from 'tdesign-react';
import Form from '@/components/Form';
import { manageUser } from '@/services/organizeService';
import { toTsOptions } from '@/utils/common';
import SelectCollapsed from '@/components/Form/SelectCollapsed';

function UsersModal({ userListOptions, visible, handleClose, detail }) {
  const [form] = Form.useForm();
  const { id, groupUserList } = detail || {};
  const users = useMemo(() => {
    return groupUserList?.map((item) => item.userId) || [];
  }, [groupUserList]);

  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (values) => {
    try {
      setSubmitting(true);
      await manageUser({ ...values, groupId: id });
      MessagePlugin.success('操作成功');
      handleClose(true);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ users });
    } else {
      form.resetFields();
    }
  }, [visible, form, users]);

  return (
    <Dialog
      header='成员管理'
      visible={visible}
      onClose={() => handleClose()}
      destroyOnClose
      confirmBtn={{ loading: submitting, content: '确定' }}
      onConfirm={() => form.submit()}
      width={650}
    >
      <Form form={form} onFinish={onSubmit} style={{ width: '90%' }}>
        <Form.FormItem label='成员' name='users'>
          <SelectCollapsed options={toTsOptions(userListOptions)} />
        </Form.FormItem>
      </Form>
    </Dialog>
  );
}

export default connect((state) => ({
  userListOptions: state.organize.userListOptions,
}))(UsersModal);
